export default class Preloader {
	static init() {
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			return;
		}

		new Preloader(document.querySelector('.preloader'));
	}

	constructor() {
		let clickedLinkIsEmailOrPhone = false;
		window.addEventListener('click', (e) => {
			clickedLinkIsEmailOrPhone = e.target && !!e.target.closest('a[href^=mailto],a[href^=tel]');
		});
		window.addEventListener('beforeunload', (e) => {
			if(clickedLinkIsEmailOrPhone) {
				return;
			}
			document.body.classList.add('body--is-closing');
		});
		window.addEventListener('pageshow', () => {
			document.body.classList.remove('body--is-closing');
		});
	}
}
